module.exports = __webpack_public_path__ + "static/img/eu.166f310.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eu.svg
// module id = tnaW
// module chunks = 4